import axios from 'axios';

export default {
    setInterceptors: () =>{
        axios.interceptors.response.use(
            function (response) {      
                return response;
            },
            function (error) {
                const errorResponse=error;
                /**
                 * API Response status 401 : Unauthorize 
                 * navigate : redirect to login page
                 * event : Generate popup error!
                 */
                if(errorResponse.response.status===404){
                    localStorage.setItem("error_throw", "yes");
                }
                else if(errorResponse.response.status===500){
                    localStorage.setItem("error_throw", "yes");
                }
                const err = errorResponse;
                return Promise.reject(err);
            }
            );
    }
}